import React, { useEffect, useState, useContext } from "react";
import { Modal, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { formatDateYYYY_MM_DD, getCurrentDateTime } from "../../functions/common-functions";
import Swal from "sweetalert2";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import { AuthContext } from "../../contexts/AuthContext";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { addEnquiryTender, getAllEnquiryTenders } from "../../services/enquiry-tender-service";
import { getPresignedURL } from "../../functions/upload";
import { ALERT_PARAMS } from "../../utils/constant";
import Validate from "../utils/Validation";
import DragDropRender from "../utils/DragDropRender";
import { getAllUOM } from "../../services/disposal-intimation-service";
import SearchSelect from "../common/SearchSelect";
import { getAllLocations } from "../../services/location-master-service";
import Select from "react-select";

const AddEditEnquiryFromContract = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        userName: context.userName,
        userId: context.userId,
    };

    const [loading, setLoading] = useState(false);
    const todayDate = getCurrentDateTime("/");
    const isEdit = props.action === "Edit";
    const [uomList, setUomList] = useState([]);
    const [divisionList, setDivisionList] = useState([]);

    const [enquiryObj, setEnquiryObj] = useState({
        EnquirySourceNumber: "-",
        EnquirySource: "Contract",
        EnquiryStatus: "Created",
        ItemCode: "",
        ItemDescription: "",
        ItemDetail: "",
        ContractPeriod: "",
        Quantity: "",
        UOM: "",
        GST: "",
        Location: "",
        ImagesAttachment: "",
        ImagesAttachmentFile: null,
        ShowImageToCustomer: false,
        Remarks: "",
        DueDate: "",
        InsertedBy: userDetails.userId,
        InsertedByName: userDetails.userName,
        InsertedOn: todayDate,
        ModifiedBy: userDetails.userId,
        ModifiedByName: userDetails.userName,
        ModifiedOn: todayDate,
        Flag: "Active",
        ItemType: "",
        Division: "",  // string format for storage
        LogisticCompany: "",

    });

    const [error, setError] = useState({
        ItemCode: "",
        ItemDescription: "",
        ItemDetail: "",
        Quantity: "",
        UOM: "",
        GST: "",
        Location: "",
        Division: "",
        LogisticCompany: ""

    });

    useEffect(() => {
        if (props.contractData) {
            if (isEdit || props.action === "View") {
                // Handle backward compatibility for division data
                const division = props.contractData.Division;
                let divisionValue = "";
                if (Array.isArray(division)) {
                    // Convert array to string for backward compatibility
                    divisionValue = division.join(", ");
                } else if (typeof division === 'string') {
                    divisionValue = division;
                }
                
                setEnquiryObj({
                    ...props.contractData,
                    DueDate: props.contractData.DueDate ? formatDateYYYY_MM_DD(new Date(props.contractData.DueDate)) : "",
                    ShowImageToCustomer: props.contractData.ShowImageToCustomer || false,
                    Division: divisionValue,
                });
            } else {
                setEnquiryObj({
                    ...enquiryObj,
                    ItemCode: props.contractData.ItemCode || "",
                    ItemDescription: props.contractData.ItemDescription || "",
                    ItemDetail: props.contractData.ItemDetail || "",
                    ItemType: props.contractData.ItemType || "",
                    GST: props.contractData.GSTRate || "",
                    ContractPeriod: props.contractData.ContractPeriod || "",
                    Location: Array.isArray(props.contractData.Location) ? props.contractData.Location.join(", ") : props.contractData.Location || "",
                });
            }
        }
        const fetchUOM = async () => {
            try {
                const uoms = await getAllUOM();
                setUomList(uoms.filter(uom => uom.DeleteIndication));
            } catch (error) {
                console.error("Error fetching UOMs:", error);
                setUomList([]);
            }
        };
        const fetchDivisions = async () => {
            try {
                if (props.contractData?.Location) {
                    const locations = await getAllLocations();
                    const contractLocations = Array.isArray(props.contractData.Location) 
                        ? props.contractData.Location 
                        : props.contractData.Location.split(", ");
                    const divisions = locations
                        .filter(loc => contractLocations.includes(loc.Location) && loc.DeleteIndication === "Active")
                        .map(loc => loc.Division)
                        .filter((div, idx, arr) => arr.indexOf(div) === idx);
                    setDivisionList(divisions);
                }
            } catch (error) {
                console.error("Error fetching divisions:", error);
                setDivisionList([]);
            }
        };
        fetchUOM();
        fetchDivisions();
    }, [props.contractData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log("handlechange",name)

        if (name === "LogisticCompany") {
            if (!/^[0-9]*$/.test(value) || value.length > 4) return;
        }

        if (name === "Quantity") {
            const allowedChars = /^[a-zA-Z0-9 ]*$/;
            if (!allowedChars.test(value) || value.length > 50) return;
        }

        if (name === "Remarks") {
            const allowedChars = /^[a-zA-Z0-9 .]*$/;
            if (!allowedChars.test(value) || value.length > 250) return;
        }

        const updates = { [name]: type === "checkbox" ? checked : value };
        if (name === "DueDate" && isEdit && value !== formatDateYYYY_MM_DD(new Date(props.contractData?.DueDate))) {
            updates.MailStatus = "Pending";
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            ...updates
        }));
    };

    const handleDivisionChange = (selectedOptions) => {
        // Convert selected options to comma-separated string
        const divisions = selectedOptions ? selectedOptions.map(opt => opt.value).join(", ") : "";
        setEnquiryObj((prevState) => ({
            ...prevState,
            Division: divisions
        }));
    };

    const handleDateBlur = (e) => {
        const { value } = e.target;
        const today = formatDateYYYY_MM_DD(new Date());
        if (value && value < today) {
            MySwal.fire({
                text: "Due Date cannot be a past date",
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            setEnquiryObj((prevState) => ({
                ...prevState,
                DueDate: ""
            }));
        }
    };

    const handleChangeStatus = async (files, fieldName) => {
        const newFile = files[0];
        if (!newFile) return;

        const maxFileSize = 20 * 1024 * 1024;
        const validationError = Validate(newFile, "imgFormats", maxFileSize);
        if (validationError) {
            MySwal.fire({
                text: validationError,
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            return;
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: newFile.name,
            [`${fieldName}File`]: newFile,
        }));
    };

    const handleDeleteDocument = (fieldName) => {
        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: "",
            [`${fieldName}File`]: null,
        }));
    };

    const uploadFile = async (signedURL, file) => {
        try {
            if (signedURL && file) {
                await axios.put(signedURL, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                });
            }
            return "";
        } catch (error) {
            console.error("File upload error:", error);
            return error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateDetails()) {
            return;
        }

        MySwal.fire({
            text: `Are you sure, do you want to ${isEdit ? "Update" : "Submit"} Enquiry/Tender?`,
            confirmButtonText: isEdit ? "Update" : "Submit",
            title: `${isEdit ? "Update" : "Submit"} Enquiry/Tender`,
            ...ALERT_PARAMS,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);

                try {
                    let enquiryNumber;
                    let submissionData = {};
                    const todayDate = getCurrentDateTime("/");

                    if (isEdit) {
                        enquiryNumber = enquiryObj.EnquiryNumber;
                        const hadDueDate = props.contractData?.DueDate;
                        const hasDueDate = enquiryObj.DueDate;
                        const shouldChangeStatus = !hadDueDate && hasDueDate;

                        submissionData = {
                            ...enquiryObj,
                            EnquiryStatus: shouldChangeStatus ? "Not Assigned" : enquiryObj.EnquiryStatus,
                            ModifiedBy: userDetails.userId,
                            ModifiedByName: userDetails.userName,
                            ModifiedOn: todayDate,
                            DueDateFlag: enquiryObj.EnquiryStatus === "Live" ? "Active" : "Inactive"
                        };
                    } else {
                        enquiryNumber = await generateEnquiryNumber();
                        submissionData = {
                            ...enquiryObj,
                            EnquiryStatus: enquiryObj.DueDate ? "Not Assigned" : "Created",
                            EnquiryNumber: enquiryNumber,
                            DueDateFlag: enquiryObj.EnquiryStatus === "Live" ? "Active" : "Inactive",
                            PK: "EnquiryTender",
                            SK: "EnquiryNumber#" + enquiryNumber,
                            ModifiedOn: todayDate
                        };
                    }

                    const fileObj = enquiryObj.ImagesAttachmentFile;
                    if (fileObj && fileObj instanceof File) {
                        try {
                            const filename = fileObj.name;
                            const signedURL = await getPresignedURL(
                                `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${filename}`
                            );
                            if (signedURL) {
                                const uploadResult = await uploadFile(signedURL, fileObj);
                                if (!uploadResult) {
                                    submissionData.ImagesAttachment = filename;
                                } else {
                                    submissionData.ImagesAttachment = "";
                                }
                            }
                        } catch (fileError) {
                            console.error("Error uploading file:", fileError);
                            submissionData.ImagesAttachment = "";
                        }
                    } else if (typeof enquiryObj.ImagesAttachment === 'string' && enquiryObj.ImagesAttachment) {
                        submissionData.ImagesAttachment = enquiryObj.ImagesAttachment;
                    }

                    const result = await addEnquiryTender(submissionData);

                    if (result.status) {
                        setLoading(false);
                        MySwal.fire({
                            text: isEdit
                                ? `Enquiry/Tender updated successfully. Enquiry Number: ${enquiryNumber}`
                                : `Enquiry/Tender submitted successfully. Enquiry Number: ${enquiryNumber}`,
                            imageUrl: successImage,
                            customClass: "swal-success"
                        });

                        props.onHide();
                        props.setReload(!props.reload);
                    } else {
                        setLoading(false);
                        MySwal.fire({
                            text: result.message,
                            imageUrl: errorImage,
                            customClass: "swal-error"
                        });
                    }
                } catch (error) {
                    setLoading(false);
                    MySwal.fire({
                        text: "Unable to process request",
                        imageUrl: errorImage,
                        customClass: "swal-error"
                    });
                }
            }
        });
    };

    const validateDetails = () => {
        let isError = false;
        const errorMsg = { ...error };

        if (!enquiryObj.Division || !enquiryObj.Division.trim()) {
            isError = true;
            errorMsg.Division = "Division is required";
        }
        if (!enquiryObj.LogisticCompany?.trim()) {
            isError = true;
            errorMsg.LogisticCompany = "Logistic Company is required";
        }


        if (!enquiryObj.ItemCode.trim()) {
            isError = true;
            errorMsg.ItemCode = "Item code is required";
        }

        if (!enquiryObj.ItemDescription.trim()) {
            isError = true;
            errorMsg.ItemDescription = "Item description is required";
        }

        if (!enquiryObj.ItemDetail.trim()) {
            isError = true;
            errorMsg.ItemDetail = "Item detail is required";
        }

        if (!enquiryObj.Quantity.trim()) {
            isError = true;
            errorMsg.Quantity = "Quantity is required";
        }

        if (!enquiryObj.UOM.trim()) {
            isError = true;
            errorMsg.UOM = "UOM is required";
        }

        if (!enquiryObj.GST || parseFloat(enquiryObj.GST) < 0) {
            isError = true;
            errorMsg.GST = "Valid GST% is required";
        }

        if (!enquiryObj.Location.trim()) {
            isError = true;
            errorMsg.Location = "Location is required";
        }

        setError(errorMsg);
        return isError;
    };

    const generateEnquiryNumber = async () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        let financialYear;
        if (currentMonth >= 4) {
            financialYear = `${currentYear}-${String(currentYear + 1).slice(-2)}`;
        } else {
            financialYear = `${currentYear - 1}-${String(currentYear).slice(-2)}`;
        }

        const allEnquiries = await getAllEnquiryTenders();
        const currentFYEnquiries = allEnquiries.filter(enquiry =>
            enquiry.EnquiryNumber && enquiry.EnquiryNumber.includes(`ENQUIRY/${financialYear}/`)
        );

        const maxSerial = currentFYEnquiries.reduce((max, enquiry) => {
            const parts = enquiry.EnquiryNumber.split('/');
            const serial = parseInt(parts[2]) || 0;
            return serial > max ? serial : max;
        }, 0);

        const serialNumber = maxSerial + 1;
        return `ENQUIRY/${financialYear}/${serialNumber}`;
    };

    const handleFileDownload = async (fileName) => {
        try {
            const enquiryNumber = enquiryObj.EnquiryNumber;
            const filePath = `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${fileName}`;
            const downloadURL = await getPresignedURL(filePath);

            if (downloadURL) {
                window.open(downloadURL, '_blank');
            } else {
                MySwal.fire({
                    text: "Unable to download file",
                    imageUrl: errorImage,
                    customClass: "swal-error"
                });
            }
        } catch (error) {
            console.error("Error downloading file:", error);
            MySwal.fire({
                text: "Error downloading file",
                imageUrl: errorImage,
                customClass: "swal-error"
            });
        }
    };

    return (
        <Modal show={props.show} onHide={props.onHide} size="xl" backdrop="static" centered>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal.Header closeButton>
                <Modal.Title>{props.action} Enquiry/Tender from Contract</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="enquirytenderform" name="enquirytenderform" autoComplete="off">
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemCode"
                                    type="text"
                                    name="ItemCode"
                                    placeholder=" "
                                    value={enquiryObj.ItemCode}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemCode">Item Code<span className="req-input">*</span></Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemDescription"
                                    type="text"
                                    name="ItemDescription"
                                    placeholder=" "
                                    value={enquiryObj.ItemDescription}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemDescription">Item Description<span className="req-input">*</span></Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="ItemDetail"
                                    name="ItemDetail"
                                    placeholder=" "
                                    value={enquiryObj.ItemDetail}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemDetail">Item Detail<span className="req-input">*</span></Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemType"
                                    type="text"
                                    name="ItemType"
                                    placeholder=" "
                                    value={enquiryObj.ItemType}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemType">Item Type</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input-select">
                                <Select
                                    isMulti
                                    name="Division"
                                    options={divisionList.map(div => ({ value: div, label: div }))}
                                    value={enquiryObj.Division ? enquiryObj.Division.split(", ").map(div => ({ value: div.trim(), label: div.trim() })) : []}
                                    onChange={handleDivisionChange}
                                    isDisabled={props.action === "Edit" || props.action === "View"}
                                    placeholder=""
                                    classNamePrefix="select"
                                    className={error.Division ? "text-field-with-error" : ""}
                                />
                                <Form.Label className={enquiryObj.Division && enquiryObj.Division.trim() ? "active" : ""}>
                                    Division <span className="req-input">*</span>
                                </Form.Label>
                                {error.Division && (
                                    <Form.Text className="text-danger">{error.Division}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Location"
                                    type="text"
                                    name="Location"
                                    placeholder=" "
                                    value={enquiryObj.Location}
                                    readOnly
                                />
                                <Form.Label htmlFor="Location">Location<span className="req-input">*</span></Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="LogisticCompany"
                                    type="text"
                                    name="LogisticCompany"
                                    placeholder=" "
                                    value={enquiryObj.LogisticCompany}
                                    onChange={handleChange}
                                    required
                                    readOnly={props.action === "Edit" || props.action === "View"}
                                />
                                <Form.Label htmlFor="LogisticCompany">Logistic Company <span className="req-input">*</span></Form.Label>
                                {error.LogisticCompany && (
                                    <Form.Text className="text-danger">{error.LogisticCompany}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Quantity"
                                    type="text"
                                    name="Quantity"
                                    placeholder=" "
                                    value={enquiryObj.Quantity}
                                    onChange={handleChange}
                                    readOnly={props.action === "Edit" || props.action === "View"}
                                />
                                <Form.Label htmlFor="Quantity">Quantity <span className="req-input">*</span></Form.Label>
                                {error.Quantity && (
                                    <Form.Text className="text-danger">
                                        {error.Quantity}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <SearchSelect
                                name="UOM"
                                label="UOM"
                                data={uomList}
                                valueField="UOMCode"
                                labelField="UOMCode"
                                value={enquiryObj.UOM}
                                onChange={handleChange}
                                error={error}
                                setError={setError}
                                required
                                disabled={props.action === "Edit" || props.action === "View"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="GST"
                                    type="text"
                                    name="GST"
                                    placeholder=" "
                                    value={enquiryObj.GST}
                                    readOnly
                                />
                                <Form.Label htmlFor="GST">GST%<span className="req-input">*</span></Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="DueDate"
                                    type="date"
                                    name="DueDate"
                                    placeholder=" "
                                    value={enquiryObj.DueDate}
                                    onChange={handleChange}
                                    onBlur={handleDateBlur}
                                    min={formatDateYYYY_MM_DD(new Date())}
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="DueDate">Due Date</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="Remarks"
                                    name="Remarks"
                                    placeholder=" "
                                    value={enquiryObj.Remarks}
                                    onChange={handleChange}
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="Remarks">Remarks</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowImageToCustomer"
                                    name="ShowImageToCustomer"
                                    label="Show Image to Customer"
                                    checked={enquiryObj.ShowImageToCustomer}
                                    onChange={handleChange}
                                    disabled={props.action === "View"}
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={12} xs={12} style={{ marginTop: '-10px' }}>
                            <Form.Label className="SubHeaderProjectDetails">Images Attachment</Form.Label>
                            <DragDropRender
                                supportedFilesLabel="Supports: JPEG, JPG, PNG, Max File Size – up to 20MB per file"
                                val={enquiryObj.ImagesAttachment}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'ImagesAttachment')}
                                handleDeleteDocEvent={() => handleDeleteDocument('ImagesAttachment')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                action={isEdit ? "Edit" : "Add"}
                                disabled={props.action === "View"}
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            {
                props.action === "View" ?
                    <></> :
                    <Modal.Footer>
                        <Button className="semiBoldToggleButton cancelBtn" variant="outline-success" onClick={props.onHide}>Cancel</Button>
                        <Button
                            variant="success"
                            className="btn-add-color semiBoldToggleButton"
                            onClick={handleSubmit}
                        >
                            {isEdit ? "Update" : "Submit"}
                        </Button>
                    </Modal.Footer>
            }
        </Modal>
    );
};

export default AddEditEnquiryFromContract;
